export const createLouvreGrillPlaneGeometry = (box: THREE.Box3) => {
    box.getSize(tempVector);
    const planeGeometry = new THREE.PlaneBufferGeometry(tempVector.x, tempVector.y);
    planeGeometry.setAttribute(
        "planeDimension",
        createPlaneDimensionAttribute(tempVector.x, tempVector.y, planeGeometry.attributes.position.count),
    );

    return planeGeometry;
};

const createPlaneDimensionAttribute = (
    width: number,
    height: number,
    vertexCount: number,
): THREE.Float32BufferAttribute => {
    const dimensions = new Float32Array(vertexCount * 2);

    for (let i = 0; i < vertexCount; i++) {
        dimensions[i * 2] = width;
        dimensions[i * 2 + 1] = height;
    }

    return new THREE.Float32BufferAttribute(dimensions, 2, false);
};

const tempVector = new THREE.Vector3();
